/**
 * Merges missedMarks into inaccuracyMarks for a marks tally object.
 * Returns the merged object with missedMarks set to 0.
 */
export const mergeMissedMarks = <T extends { inaccuracyMarks?: number; missedMarks?: number }>(
  data: T
): T => {
  return {
    ...data,
    inaccuracyMarks: (data.inaccuracyMarks ?? 0) + (data.missedMarks ?? 0),
    missedMarks: 0,
  };
};
